<div class="upload-to-relay-alert-container">
  <h1 class="title">Important</h1>
  <div class="message">Go to Relay and Upload the PDF</div>
  <div class="actions">
    <p-button label="Yes, I did" (onClick)="confirmUploadToRelay()" />
  </div>
</div>
